/**
 * Created by vwiny on 8/28/2017.
 */
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewChild, ChangeDetectorRef, forwardRef
} from '@angular/core';
import { LMRouteComponentService } from '@services/lm-route-component.service';

@Component({
  selector: 'lm-helper-list',
  template: `
    <!--
    contained no longer in use. All lists are technically contained in that they are full widht height.
    [style.padding-top]="!contained ? '0px' : null"-->
    <lm-list #lmhelperlist
        *ngIf="listSpec"
        [listUrlInfo]="listUrlInfo"
        [listSpec]="listSpec"
        [helperListOptions]="helperListOptions"
        [fromDataView]="fromDataView"
    ></lm-list>
  `,
  providers: [ LMRouteComponentService ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LMHelperListDialogComponent implements OnInit, AfterViewInit {
  @ViewChild(forwardRef(() => 'lmListComponent')) lmListComponent; // : LMListComponent;

  @Input() listUrlInfo: LMListUrlInfo;
  @Input() listSpec: LMListSpec;
  @Input() fromDataView: LMDataView;
  @Input() helperListOptions: LMHelperListOptions;

  constructor(private changeDetectionRef: ChangeDetectorRef) {}

  ngOnInit() {}

  ngAfterViewInit() { }

  triggerDetectChanges() {
    // DETECT CHANGES
    this.changeDetectionRef.detectChanges();
  }
}
